import type { SVGProps } from 'react'

import { cn } from '@/shared/lib/utils'

const ChackInProgressIcon = ({
	className,
	...props
}: SVGProps<SVGSVGElement>) => (
	<svg
		fill='currentColor'
		viewBox='0 0 24 24'
		role='presentation'
		width={16}
		height={16}
		className={cn('cmp-icon', className)}
		{...props}
	>
		<path
			fillRule='evenodd'
			d='M9.854 1.21A11 11 0 0 1 12 1a10.96 10.96 0 0 1 8.15 3.612 10.96 10.96 0 0 1 2.847 7.662 10.96 10.96 0 0 1-3.61 7.876A10.96 10.96 0 0 1 12 23q-1.1-.002-2.146-.21a1 1 0 1 1 .388-1.961 9 9 0 0 0 1.983.168 8.96 8.96 0 0 0 6.444-2.953 8.97 8.97 0 0 0 2.328-6.27 8.96 8.96 0 0 0-2.953-6.442A8.97 8.97 0 0 0 12 3a9 9 0 0 0-1.758.171 1 1 0 0 1-.388-1.962m-2.58 1.918A1 1 0 0 1 7 4.515 9.1 9.1 0 0 0 4.515 7a1 1 0 1 1-1.662-1.112 11.1 11.1 0 0 1 3.035-3.035 1 1 0 0 1 1.387.275m-4.89 5.94a1 1 0 0 1 .787 1.174 9 9 0 0 0 0 3.516 1 1 0 0 1-1.962.388 11 11 0 0 1 0-4.292 1 1 0 0 1 1.175-.787m.744 7.657A1 1 0 0 1 4.515 17 9.1 9.1 0 0 0 7 19.485a1 1 0 1 1-1.112 1.662 11.1 11.1 0 0 1-3.035-3.034 1 1 0 0 1 .275-1.388m14.08-6.768a1 1 0 0 0-1.415-1.414L11 13.336l-2.793-2.793a1 1 0 0 0-1.414 1.414l3.359 3.359a1.2 1.2 0 0 0 1.697 0z'
			clipRule='evenodd'
		/>
	</svg>
)

export default ChackInProgressIcon
